(() => {
  customElements.whenDefined('cart-items').then(() => {
    const CartItems = customElements.get('cart-items');
    if (CartItems.prototype.zkCheckoutAgreementSync) return;
    const renderContents = CartItems.prototype.renderContents;

    CartItems.prototype.renderContents = function (...args) {
      const agreementId = this.onCartPage ? 'agreementCheckboxMaincart' : 'agreementCheckboxMinicart';
      const checked = document.getElementById(agreementId)?.checked;
      const result = renderContents.apply(this, args);
      const checkbox = document.getElementById(agreementId);
      // Use the customer's existing choice, never a replacement fragment's default.
      if (checkbox && typeof checked === 'boolean' && typeof agreementCheckbox !== 'undefined') {
        checkbox.checked = checked;
        agreementCheckbox.checkAgreement(checkbox);
      }
      return result;
    };
    CartItems.prototype.zkCheckoutAgreementSync = true;

    // Newly rendered cart checkboxes no longer have their original change listener.
    document.addEventListener('change', (event) => {
      const checkbox = event.target;
      if (checkbox.matches('#agreementCheckboxMinicart, #agreementCheckboxMaincart') &&
          typeof agreementCheckbox !== 'undefined') {
        agreementCheckbox.checkAgreement(checkbox);
      }
    });
  });
})();
